import React from "react";
import {useTranslation} from "react-i18next";
import SectionHeader from "../../../../util/component/SectionHeader";
import AncillaryContent from "./AncillaryContent";
import {Box} from "@mui/material";

const AncillaryContainer = () => {

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    return (
        <Box>
            <SectionHeader title={t("translation:auths.SCOPE_PRC_VIEW_ANCILLARY.name")}/>
            <AncillaryContent readOnly={false}/>
        </Box>
    );
};

export default AncillaryContainer;